(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mer-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__merProductCardBound) return;
    window.__merProductCardBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest('form[data-mer-pc-add]') : null;
      if (!form || !window.MerCart) return; /* without the cart script the form posts normally */
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-mer-pc-label]');
      if (!button || button.disabled) return;

      var idle = label ? label.textContent : '';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Adding';

      /* addToCart redraws the cart and opens the drawer itself */
      window.MerCart.addToCart(Number(form.elements.id.value), 1)
        .then(function () {
          window.MerCart.toast('Added to cart');
        })
        .catch(function (error) {
          window.MerCart.toast((error && error.message) || 'Could not add to cart');
        })
        .then(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (label) label.textContent = idle;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
